// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"c099999c","353":"bdf5d445"}[chunkId] + ".js";
};